import React, { Component } from 'react'
import Inputs from '../../shared/FormComponents/Inputs'
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import './ChangePassword.css'

export default class ChangePassword extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      passwordFormValid: false,
      passwordChangeServerStatus: false,
      forgotPasswordData:{
        password: '',
        confPassword: '',
        oldPassword: '',
      },
      inputStates: {
        password: false,
        confPassword: false,
        oldPassword: false,
      }
    };
  }


  onChangePassword = (key, value, valid) => {
    let state = _.extend({}, this.state);
    state.forgotPasswordData[key] = value;
    state.inputStates[key] = valid;
    this.setState(state, () => this.validatePasswordForm());
  };

  validatePasswordForm = () => {
    const validationStates = _.extend({}, this.state.inputStates);
    const { password, confPassword } = this.state.forgotPasswordData;
    const checkFields = password.trim() && confPassword.trim() ? true : false;
    const key = Object.values(validationStates).indexOf(false) !== -1;
    const state = !key;
    this.setState({ passwordFormValid: state && checkFields });
  };

  onDataChange = (key, value, valid) => {
    const state = _.extend({}, this.state);
    state.inputStates[key] = valid;
    state.forgotPasswordData[key] = value;
    this.setState(state, () => this.validateForm());
  };

  validateForm = () => {
    let validationStates = _.extend({}, this.state.inputStates);
    let key = Object.values(validationStates).indexOf(false) !== -1;
    let state = !key;
    this.setState({ formValid: state });
  }


  changeUserPassword = () => {
    const body = {
        oldPassword: this.state.forgotPasswordData.oldPassword,
        newPassword: this.state.forgotPasswordData.password
    };
    this.props.changeUserPassword(body);
    // if (body.email && body.code) {
    //   this.props.onForgotPasswordConfirm(body);
    // }

  }

  elementInfiniteLoad() {
    return (
        <div className='col-sm-12'>
            <div className='spinner3'>
            <div className='rect1'/>
            <div className='rect2'/>
            <div className='rect3'/>
            <div className='rect4'/>
            <div className='rect5'/>
            </div>
        </div>
    );
}

  render() {
    const passwordConfirm = this.state.forgotPasswordData.password === this.state.forgotPasswordData.confPassword ? true : false;
    
    return (
       
            
                <div className='opacity-overlay ' style={{'display': 'block'}}>
                    <div className="container">
                        <div className="popup-wrapper">
                            <div className="col-xs-12 col-sm-4 popup-content">
                                { !this.props.createdProjectFetching &&
                                    <div>
                                        <div className='modal-header'>
                                            <h5>Change Password</h5>
                                        </div>
                                        <div className='modal-body'>
                                            <form>
                                            <div className="form-group">
                                                    <Inputs
                                                        type="password"
                                                        className="form-control"
                                                        value={this.state.forgotPasswordData.oldPassword}
                                                        required={ true }
                                                        onChange={ (value, valid) => this.onChangePassword('oldPassword', value, valid)}
                                                        placeholder='oldPassword'
                                                        // onChange={ (value, valid) => this.onDataChange('loginPassword', value, valid)} 
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <Inputs
                                                        type="password"
                                                        className="form-control"
                                                        value={this.state.forgotPasswordData.password}
                                                        required={ true }
                                                        onChange={ (value, valid) => this.onChangePassword('password', value, valid)}
                                                        placeholder='Password'
                                                        // onChange={ (value, valid) => this.onDataChange('loginPassword', value, valid)} 
                                                    />
                                                </div>
                                                <div className='form-group'>
                                                    <Inputs
                                                        type="confirm_password"
                                                        className="form-control"
                                                        placeholder='Confirm Password'
                                                        value={this.state.forgotPasswordData.confPassword}
                                                        password={this.state.forgotPasswordData.password}
                                                        required={ true }
                                                        onChange={ (value, valid) => this.onChangePassword('confPassword', value, valid)}
                                                        errorMessage={'5555'} />
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => this.changeUserPassword()}
                                                    disabled={!this.state.passwordFormValid || !passwordConfirm}
                                                    className="btn btn-success">
                                                    Change 
                                                    {this.props.forgotPasswordPending && <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>}
                                                </button>
                                                <div 
                                                    onClick={() => this.props.closeModal()} 
                                                    className="btn btn-cancel">
                                                        Close
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            
            
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.jsx